import { Button, Stack } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { YARD_DRAWERS_WIDTH } from '@yard/pages/YardSetup/helpers/yard-view.utils'
import { FC } from 'react'

type Props = {
  isFilterDrawerOpen: boolean
  onSubmit: () => Promise<void>
  onCancel: () => void
}

export const AllocationRulesActions: FC<Props> = props => {
  const { isFilterDrawerOpen, onSubmit, onCancel } = props
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  return (
    <Stack
      direction='row'
      spacing={1}
      alignItems='center'
      sx={{
        position: 'absolute',
        right: `calc(${isFilterDrawerOpen ? YARD_DRAWERS_WIDTH : 0}px + ${theme.customSpacing.l})`,
        transition: 'right 225ms cubic-bezier(0, 0, 0.2, 1)',
      }}
    >
      <Button variant='contained' color='inherit' onClick={() => onCancel()}>
        {t('cancel', 'Cancel')}
      </Button>
      <Button variant='contained' color='primary' onClick={async () => await onSubmit()}>
        {t('submit', 'Submit')}
      </Button>
    </Stack>
  )
}
